export class DataCatalogTagResourceRef {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "DataCatalogTagResourceType",
            "format": ""
        },
        {
            "name": "namespacePath",
            "baseName": "namespacePath",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "datasetName",
            "baseName": "datasetName",
            "type": "string",
            "format": ""
        },
        {
            "name": "columnName",
            "baseName": "columnName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogTagResourceRef.attributeTypeMap;
    }
    constructor() {
    }
}
